function resolveValue(value?: string) {
    return value?.trim() ? value : undefined;
}

function parseEncodedValueToJson(value: string) {
    const json = resolveValue(decodeURIComponent(value));

    if (json) {
        return JSON.parse(json);
    }

    return undefined;
}

function getVisitorIdFromAtUserId(atUserId?: string) {
    if (atUserId) {
        try {
            const parsed = parseEncodedValueToJson(atUserId);

            return parsed?.val ? String(parsed.val) : undefined;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(
                'getVisitorIdFromAtUserId error parsing atUserId:',
                error
            );
        }
    }

    return undefined;
}

function getVisitorIdFromPcid(pcid?: string) {
    if (pcid) {
        try {
            const parsed = parseEncodedValueToJson(pcid);

            return parsed?.browserId ? String(parsed.browserId) : undefined;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('getVisitorIdFromPcid error parsing pcid:', error);
        }
    }

    return undefined;
}

type GetVisitorIdParameters = {
    atUserId?: string;
    pcid?: string;
};

export function getVisitorId({ atUserId, pcid }: GetVisitorIdParameters) {
    let visitorId: string | undefined;

    if (pcid) {
        visitorId = getVisitorIdFromPcid(pcid);
    }

    if (atUserId && !visitorId) {
        visitorId = getVisitorIdFromAtUserId(atUserId);
    }

    return visitorId;
}
